import { t } from '@ankr.com/common';
import { ChainSubType } from '@ankr.com/chains-list';

import { Tab } from 'modules/common/hooks/useTabs';

export const getChainSubtypeTabs = (): Tab<ChainSubType>[] => [
  {
    id: ChainSubType.Athens3,
    title: t('chain-item.chain-subtypes.athens3'),
  },
];
